/**
 * useRouletteTeamData — dados da equipe para configurar uma roleta.
 *
 * Carrega company + membros + categorias + agentes-por-membro (companyService),
 * a base comum das DUAS telas de roleta (tool nativa do agente e grupos da aba
 * Etiquetas). Alimenta o RouletteConfigForm: pool com pesos, semente por
 * categoria e o guard (dono/admin/membro-com-autopilot ficam de fora).
 *
 * Só dispara quando `isOpen` vira true (drawers montados ociosos). error.kind:
 * 'no_company' | 'forbidden' | 'network'.
 */
import { useCallback, useEffect, useState } from 'react';
import companyService from '../services/global/companyService';

const EMPTY = {
  loading: false, error: null,
  company: null, members: [], categories: [], memberAgents: {},
};

export default function useRouletteTeamData(isOpen) {
  const [state, setState] = useState(EMPTY);

  const reload = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const me = await companyService.getMyCompany();
      if (!me?.company?.id) {
        setState({
          ...EMPTY,
          error: {
            kind: 'no_company',
            msg: 'Sua conta não é uma Conta Empresa, então não há equipe para a roleta.',
          },
        });
        return;
      }
      const cid = me.company.id;
      const [mem, cats, ma] = await Promise.all([
        companyService.listMembers(cid),
        companyService.listCategories(cid),
        companyService.getMemberAgents(cid),
      ]);
      setState({
        loading: false, error: null,
        company: me.company,
        members: (mem?.data) || [],
        categories: cats || [],
        memberAgents: ma || {},
      });
    } catch (err) {
      const status = err?.response?.status;
      const error = status === 403
        ? { kind: 'forbidden', msg: 'Apenas o administrador da empresa pode configurar a roleta.' }
        : { kind: 'network', msg: 'Não foi possível carregar a equipe.' };
      console.error('[useRouletteTeamData] load:', err);
      setState({ ...EMPTY, error });
    }
  }, []);

  useEffect(() => {
    if (isOpen) reload();
  }, [isOpen, reload]);

  return { ...state, reload };
}
